<div class="border-0 rounded-lg border-0 overflow-hidden">
  <div class="rounded-lg border-0">
    <div class="mb-3 p-4 rounded-lg">
      <!-- Timeline Section -->
      <div class="border-0 rounded-lg mb-5">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div>
            <p class="profile-title mb-1 text-x fw-bold">Profile Completion</p>
            <p class="profile-subtitle mb-0 text-xxs">
              {{ profile_completion.completion_percentage }}% complete <span class="dot-separator">•</span> {{ profile_completion.unanswered_questions  }} steps remaining
            </p>
          </div>
        </div>

        <div class="custom-progress-container mt-1">
          <div class="custom-progress-bar" :style="'width:' + profile_completion.completion_percentage + '%'"></div>
        </div>
      </div>

      <div class="row">
        <!-- Verification Section -->
        <div class="col-md-12 mb-5">
          <p class="profile-title mb-1 text-x fw-bold">Verification Status</p>

          <!-- Status Card -->
          <div class="card mb-3 shadow border-0 verification-card">
            <div class="card-body d-flex align-items-center py-2 px-3">
              <div class="rounded p-2 me-3 bg-green-dark d-flex align-items-center justify-content-center">
                <i class="bi bi-person-gear fs-5 text-white"></i>
              </div>
              <div>
                <p class="fw-bold mb-0 small text-xxs">Manual Verification</p>
                <small class="text-muted text-xxs">Verified</small>
              </div>
            </div>
          </div>

          <!-- Total Flags Card -->
          <div class="card shadow border-0 verification-card">
            <div class="card-body d-flex align-items-center justify-content-between py-2 px-3">
              <div class="d-flex align-items-center">
                <div class="rounded p-2 me-3 bg-green-dark">
                  <i class="bi bi-gear text-white"></i>
                </div>
                <div>
                  <p class="fw-bold mb-0 small text-xxs">Auto Verification</p>
                  <small class="text-muted text-xxs">Pass</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Requests Section -->
        <div class="col-md-12">
          <p class="profile-title mb-1 text-x fw-bold">Requests</p>
          <div class="card shadow border-0">
            <div class="card-body">
              <div v-if="requests.length > 0">
                <ul class="list-unstyled mb-3">
                  <li
                    v-for="(item, index) in requests"
                    :key="index"
                    class="d-flex align-items-center mb-2"
                  >
                    <i class="bi bi-clipboard-check me-2 text-dark text-x"></i>
                    <span class="text-muted text-xxs">{{ item }}</span>
                  </li>
                </ul>
                <div class="text-end">
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                    @click="redirect_to_requested_information"
                  >
                    View
                  </button>
                </div>
              </div>
              <div v-else class="text-muted text-center text-xxs">No requests were made</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>